import type { Location, NavigateFunction } from 'react-router'

import getSafeLoginUrl from './safe-login'

const createSafeLoginRedirect =
	(navigate: NavigateFunction, { hash, pathname, search }: Location) =>
	() => {
		if (pathname === '/login') return

		void navigate(getSafeLoginUrl(pathname, search, hash), { replace: true })
	}

export default createSafeLoginRedirect
